import React from 'react'
import Loader from "react-loader-spinner";
export default function PaginationLoader() {
    return (
      <div className="text-center">
        <Loader type="ThreeDots" className="text-center text-primary opacity-75" color="currentColor" height={40} width={40} />
      </div>
    );
}
